import { SaveButton } from "components/Buttons"
import {
  AsyncTypeahedSelect,
  CheckboxField,
  RadioField,
} from "components/RenderInput"
import { FORM_NAMES } from "constants/index"
import React, { useEffect } from "react"
import { connect } from "react-redux"
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap"
import { Field, change, formValueSelector, initialize } from "redux-form"
import {
  getDocumentsSetup,
  getMetaTags,
  getUsersBySearch,
  updateDocumentsSetup,
} from "store/actions"

const SetupTab = props => {
  useEffect(() => {
    props.getDocumentsSetup({
      menu_item_id: props?.feature?.id,
      dashboard: true,
    })
    props?.getMetaTags({ hide_for_business_unit: 1 })
  }, [])

  useEffect(() => {
    if (props.documentsSetup) {
      props.initializeForm({
        document_list_form: {
          uploadsEnabled: props.documentsSetup.can_upload === 1,
          uploadUsers: props?.documentsSetup?.media_upload_access_type,
          uploadUsersSearch: props?.documentsSetup?.mediaUploadUsers?.map(
            user => ({
              ...user,
              label: `${user.first_name} ${user.last_name} (${user.email})`,
              value: user.id,
            })
          ),
          uploadTagSearch: props?.documentsSetup?.upload_tags?.map(tag => ({
            ...tag,
            label: tag?.tag,
            value: tag?.id,
          })),
        },
      })
    }
  }, [props.documentsSetup])

  const handleSave = () => {
    props.updateDocumentsSetup({
      ...props?.documentsSetup,
      can_upload: props.formValues?.uploadsEnabled ? 1 : 0,
      media_upload_access_type: props?.formValues?.uploadUsers,
      mediaUploadUsers:
        props.formValues?.uploadUsers === "users"
          ? props.formValues?.uploadUsersSearch
          : [],
      upload_tags:
        props.formValues?.uploadUsers === "tags"
          ? props.formValues?.uploadTagSearch
          : [],
      upload_tag_ids:
        props.formValues?.uploadUsers === "tags"
          ? props.formValues?.uploadTagSearch?.map(tag => tag?.id)
          : [],
    })
  }

  return (
    <React.Fragment>
      <Card className="my-3">
        <CardHeader>
          <h5>Configs</h5>
        </CardHeader>
        <CardBody>
          <Row>
            <Col xs={12} className="my-1">
              <Field
                name="uploadsEnabled"
                label="Upload Media from Local Devices (photos & videos)"
                component={CheckboxField}
                onChange={(event, newValue) => {
                  if (newValue) {
                    props?.change("document_list_form.uploadUsers", "all")
                  } else {
                    props?.change("document_list_form.uploadUsers", "none")
                  }
                }}
              />
            </Col>
            {props?.formValues?.uploadsEnabled && (
              <>
                <Row
                  className={
                    props?.formValues?.uploadUsers === "users" ? "" : "mb-3"
                  }
                >
                  <Col xs={12} className="my-1">
                    <Field
                      name="uploadUsers"
                      value="all"
                      type="radio"
                      label="All Users"
                      component={RadioField}
                    />
                  </Col>
                  <Col xs={12} className="my-1">
                    <Field
                      name="uploadUsers"
                      value="users"
                      type="radio"
                      label="Selected Users"
                      component={RadioField}
                    />
                  </Col>
                  <Col xs={12} className="my-1">
                    <Field
                      name="uploadUsers"
                      value="tags"
                      type="radio"
                      label="Selected Tags"
                      component={RadioField}
                    />
                  </Col>
                  {props.formValues?.uploadUsers === "users" && (
                    <Col xs={12} className="my-2">
                      <Field
                        name="uploadUsersSearch"
                        component={AsyncTypeahedSelect}
                        placeholder="Search for specific users"
                        options={props.usersBySearch.map(user => ({
                          ...user,
                          label: `${user.first_name} ${user.last_name} (${user.email})`,
                          value: user.id,
                        }))}
                        inlineValue={false}
                        onInputChange={text =>
                          props.getUsersBySearch({
                            t: text,
                            include_admins: true,
                            ...(props?.selectedEvent
                              ? { event_id: props.selectedEvent.id }
                              : {}),
                          })
                        }
                        isMulti={true}
                        onMenuClose={() => {
                          props.getUsersBySearch({
                            include_admins: true,
                            ...(props?.selectedEvent
                              ? { event_id: props.selectedEvent.id }
                              : {}),
                          })
                        }}
                      />
                    </Col>
                  )}
                  {props.formValues?.uploadUsers === "tags" && (
                    <Col xs={12} className="my-2">
                      <Field
                        name="uploadTagSearch"
                        placeholder="Enter tag"
                        component={AsyncTypeahedSelect}
                        options={props?.metaTags.map(tag => ({
                          ...tag,
                          label: tag.tag,
                          value: tag.id,
                        }))}
                        isMulti={true}
                      />
                    </Col>
                  )}
                </Row>
              </>
            )}
          </Row>
        </CardBody>
      </Card>
      <Row className="d-flex justify-content-center">
        <Col xs="auto">
          <SaveButton type="button" content="Save" onClick={handleSave} />
        </Col>
      </Row>
    </React.Fragment>
  )
}

const selector = formValueSelector(FORM_NAMES.DOCUMENT_LIST)

const mapStateToProps = state => ({
  selectedEvent: state.experiences.selectedEvent,
  vendorId: state.Login.vendorId,
  userId: state.Login.authUser.id,
  formValues: selector(state, FORM_NAMES.DOCUMENT_LIST),
  usersBySearch: state.SiteUsers.usersBySearch,
  metaTags: state.Tags.metaTags,
  documentsSetup: state.Document.documentsSetup,
})

const mapDispatchToProps = dispatch => ({
  initializeForm: values =>
    dispatch(initialize(FORM_NAMES.DOCUMENT_LIST, values)),
  getUsersBySearch: values => dispatch(getUsersBySearch(values)),
  getMetaTags: values => dispatch(getMetaTags(values)),
  change: (field, value) =>
    dispatch(change(FORM_NAMES.DOCUMENT_LIST, field, value)),
  getDocumentsSetup: values => dispatch(getDocumentsSetup(values)),
  updateDocumentsSetup: values => dispatch(updateDocumentsSetup(values)),
})

export default connect(mapStateToProps, mapDispatchToProps)(SetupTab)
